// BlogDetailPage.jsx
import React from 'react';
import { Row, Col, Avatar } from 'antd';
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  LinkOutlined,
} from '@ant-design/icons';
import styles from "./index.module.scss";


const BlogDetailPage = () => {
  return (
    <div className={styles.blogDetailPage}>
      {/* Hero Banner */}
      <div className={styles.banner}>
        <h1>Imprint.live Launches with a Vision for a Kinder Internet</h1>
        <p className={styles.subtitle}>
          A letter from Hakeem & Andrews, Founders of The BuddyHood Ltd and Imprint.Live
        </p>
      </div>

      {/* Author & Content Layout */}
      <Row gutter={[32, 32]} className={styles.mainContent}>
        {/* Sidebar */}
        <Col xs={24} md={6}>
          <div className={styles.sidebar}>
            <div className={styles.authorBox}>
              <Avatar size={64} src="https://i.pravatar.cc/150?img=3" />
              <h3>Seraphina Isabella</h3>
              <p>Journalist & Culture Writer</p>
              <p className={styles.meta}>29 May 2025 • 10 mins read</p>
            </div>

            <div className={styles.contents}>
              <h4>Contents</h4>
              <ul>
                <li><a href="#echo">Echo Chambers: Digital Comfort</a></li>
                <li><a href="#history">Historical Cost of Ignoring Voices</a></li>
                <li><a href="#pop">Popular Culture & Listening</a></li>
              </ul>
            </div>

            <div className={styles.share}>
              <h4>Share This Blog</h4>
              <div className={styles.icons}>
                <FacebookFilled />
                <TwitterSquareFilled />
                <LinkedinFilled />
                <LinkOutlined />
              </div>
            </div>
          </div>
        </Col>

        {/* Blog Content */}
        <Col xs={24} md={18}>
          <div className={styles.contentArea}>
            <p className={styles.intro}>
              As a mixed-race couple from very different socioeconomic and cultural backgrounds...
            </p>

            <img
              src="https://images.unsplash.com/photo-1581090700227-1c65e7b2cfb1"
              alt="Brain in cage"
              className={styles.featureImage}
            />

            <section id="echo">
              <h2>Echo Chambers: Digital Comfort, Mental Confinement</h2>
              <p>
                Echo chambers offer a sense of validation and reinforcement...
              </p>
            </section>

            <section id="history">
              <h2>The Historical Cost of Ignoring Diverse Voices</h2>
              <p>
                History is filled with examples where minority voices were ignored...
              </p>
            </section>

            <section id="pop">
              <h2>What Popular Culture is Telling Us—We’re Willing to Listen</h2>
              <p>
                In today’s world, popular culture influences our understanding of societal norms...
              </p>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BlogDetailPage;
